module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.proShow && _vm.row.start.subject != '') ? _c('ScoreStartArmyPro', {
    attrs: {
      "row": _vm.row.start,
      "list": _vm.row.list,
      "start": _vm.row.start.subject
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.proShow && _vm.row.start.subject != '') ? _c('ScoreStartArmy2', {
    attrs: {
      "row": _vm.row.start,
      "list": _vm.row.list,
      "start": _vm.row.start.subject
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50af4d1b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/score/ScoreShowPro.vue
// module id = 2395
// module chunks = 0